// extracted by mini-css-extract-plugin
export default {"backGround":"splash_backGround__T1Lkz","titleBG":"splash_titleBG__jNw7t","title":"splash_title__IgLpl","funForm":"splash_funForm__nicl7"};